<template>
  <v-select
    :label="label"
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    @change="$emit('change', $event)"
    @click:append="$emit('clickappend')"
    v-bind="$attrs"
  >
    <template v-slot:selection="{ item }">
      <slot name="selection" :item="item">
        {{ item[itemText] || item }}
      </slot>
    </template>
    <template v-slot:item="{ item }">
      <slot name="item" :item="item">
        {{ item[itemText] || item }}
      </slot>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'Select',
  props: {
    label: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    }
  }
}
</script>